// extracted by mini-css-extract-plugin
module.exports = {"SectionTabs":"style_SectionTabs__2CxE3","tab":"style_tab__QfKIt","shifted":"style_shifted__q1yy7","active":"style_active__3jPGM"};